import { render, staticRenderFns } from "./ConsumableQuery.vue?vue&type=template&id=6fa27c00&scoped=true"
import script from "./ConsumableQuery.vue?vue&type=script&lang=js"
export * from "./ConsumableQuery.vue?vue&type=script&lang=js"
import style0 from "./ConsumableQuery.vue?vue&type=style&index=0&id=6fa27c00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa27c00",
  null
  
)

export default component.exports